var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heatmap-chart",style:({
    width: _vm.config.chartWidth + 'px',
    height: _vm.config.chartHeight + 'px',
  })},[_c('div',{staticClass:"heatmap-chart-wrapper"},[_c('div',{staticClass:"heatmap-chart-title",style:(_vm.titleBarInlineStyle)},[_vm._v(" "+_vm._s(_vm.config.chartTitle)+" ")]),(_vm.borderImgUrl)?_c('img',{staticClass:"heatmap-chart-border",style:(_vm.chartBorderTemplateImageStyle),attrs:{"src":_vm.borderImgUrl,"alt":""}}):_vm._e()]),_c('div',{ref:"heatMap",staticClass:"heatmap-chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }